<!-- splash screen -->
<div #splashScreen class="splash-screen">
  <img src="./assets/media/logos/spinner-logo.png" alt="Logo" />
  <mat-spinner style="stroke: #00aaff" diameter="40"></mat-spinner>
</div>
